import Script from 'next/script';
import * as React from 'react';

declare global {
  interface Window {
    grecaptcha?: any;
  }
}

export type ReCAPTCHATheme = 'dark' | 'light';
export type ReCAPTCHAType = 'image' | 'audio';
export type ReCAPTCHASize = 'compact' | 'normal' | 'invisible';
export type ReCAPTCHABadge = 'bottomright' | 'bottomleft' | 'inline';

export interface ReCAPTCHAProps {
  sitekey: string;
  onChange?: (token: string | null) => void;
  theme?: ReCAPTCHATheme;
  size?: ReCAPTCHASize;
  badge?: ReCAPTCHABadge;
  dataAction?: string; // not used with v2 recaptcha
  [key: string]: any;
}

const ReCAPTCHA = (props: ReCAPTCHAProps) => {
  const recaptchaRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const checkRecaptchaLoaded = setInterval(() => {
      if (
        window.grecaptcha?.enterprise &&
        window.grecaptcha?.enterprise?.render &&
        recaptchaRef.current &&
        !recaptchaRef.current.hasChildNodes()
      ) {
        clearInterval(checkRecaptchaLoaded);
        renderReCAPTCHA();
      }
    }, 100);

    return () => clearInterval(checkRecaptchaLoaded);
  }, []);

  const handleCallback = (token: string) => {
    if (props.onChange) {
      props.onChange(token);
    }
  };

  const renderReCAPTCHA = () => {
    const recaptcha = window.grecaptcha?.enterprise;
    if (recaptcha && recaptchaRef.current) {
      recaptcha.render(recaptchaRef.current, {
        sitekey: props.sitekey,
        badge: props.badge,
        theme: props.theme,
        size: props.size,
        callback: handleCallback,
      });
    }
  };

  return (
    <>
      <Script src="https://www.google.com/recaptcha/enterprise.js?render=explicit" />
      <div id="recaptcha-container" ref={recaptchaRef}></div>
    </>
  );
};

export default ReCAPTCHA;
